import React, { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

import Image from 'Demora/image';

import { areFeelsLoaded } from '../GetFeels';

import Loading from 'Demora/Loading';

import Tabs from 'Demora/Tabs';

import classnames from 'classnames';

import Feed from '../Feed/Feed';

import socialHttp from '../../../../utils/socialHttp';

import ProfileHeader from 'resources/assets/react-app/uiHooks/react-social/profileHeader';

import ProfileNextToName from 'resources/assets/react-app/uiHooks/react-social/profileNextToName';

import ProfileUnderProfileImage from 'resources/assets/react-app/uiHooks/react-social/profileUnderProfileImage';

import { withRouter } from 'react-router-dom';

import Followers from '../../Relationships/Followers/Followers';

import ProfileSettings from '../ProfileSettings/ProfileSettingsButton';

import GroupJoin from './GroupJoin';

import modal from 'Demora/modals/modal';

import { Scrollbars } from 'react-custom-scrollbars-2';

import BlockUser from '../ProfileSettings/BlockUser';

import ShowUserSnapShot from '../ShowUserSnapShot';

import UserSearch from '../../Relationships/UserSearch';

class Group extends Component {
	constructor(props) {
		super();

		const spar = new URLSearchParams(props.location.search);

		this.state = {
			obj: props.obj,
			activeTab: spar.get('tab') == 'join_requests' ? 1 : 0,
			joinRequests: null,
		};
	}

	componentDidMount() {
		this.getJoinRequests();
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	getJoinRequests() {
		socialHttp('get', '/data/groups/' + this.state.obj + '/getJoinRequests/')
			.then((data) => {
				if (!this.unmounted) {
					this.setState({
						joinRequests: data.usersRequestingJoin,
					});
				}
			})
			.catch((e) => {
				throw e;
			});
	}

	actionJoin(obj, accept) {
		socialHttp(
			'post',
			'/data/groups/' + this.state.obj + '/getJoinRequests/' + obj,
			{ accept: accept }
		)
			.then((data) => {
				const joinRequests = this.state.joinRequests;

				let index = joinRequests.indexOf(obj);
				if (index !== -1) joinRequests.splice(index, 1);

				this.setState({
					joinRequests,
				});
			})
			.catch((e) => {
				throw e;
			});
	}

	joinGroup = () => {
		const props = this.props;

		const state = this.state;

		const feed = props.feed[state.obj];

		modal({
			id: 'join_public_group',
			header: 'Join',
			body: <GroupJoin joinCode={feed.joinCode} />,
		});
	};

	tabs = () => {
		const state = this.state;

		const props = this.props;

		const { obj, joinRequests } = state;

		const feed = props.feed[obj];

		const joinLink = window.location.origin + '/groups/' + feed.joinCode + '/join';

		const admin = parseFloat(feed.role) == 255;

		const tabs = [
			{
				title: 'Posts',
				pane: (
					<div>
						<div className={classnames('animated fadeIn mt-2')}>
							<Feed match={props.match} obj={obj} />
						</div>
						<div className='space'></div>
					</div>
				),
			},
			{
				tabLabel: (
					<span>
						Join Requests
						<div
							className='comment-badge d-inline-block'
							style={{ width: '10px' }}
							data-count={
								joinRequests && joinRequests.length ? joinRequests.length : null
							}
						>
							&nbsp;
						</div>
					</span>
				),
				title: 'Join Requests',
				pane: (
					<div>
						<div className='text-center mb-5'>
							You can invite members to your group by sending them the link
							below.
							<br />
							<div
								style={{
									wordBreak: 'break-all',
								}}
							>
								{joinLink}
							</div>
						</div>

						{joinRequests === null ? (
							<Loading />
						) : (
							<div>
								{joinRequests.length == 0 && (
									<div className='text-center'>
										There are no users requesting to join
									</div>
								)}

								{joinRequests.map((obj) => {
									const user = props.users[obj];

									if (!user) {
										return null;
									}

									return (
										<div className='row mb-1' key={obj}>
											<div className='col profile-photo-container'>
												<img
													src={!user ? '' : Image(user.image, 100)}
													className='profile-photo rounded show-in-modal'
													style={{
														padding: '2px',
														border: 'solid 1px #bbb',
														width: '100px',
														height: '100px',
													}}
												/>
												<ProfileUnderProfileImage obj={obj} />
											</div>
											<div className='col profile-opts flex-grow-3'>
												<div>
													<span className='user-name'>
														{user.first_name + ' ' + user.last_name}
													</span>

													<ProfileNextToName obj={obj} />
												</div>

												<ProfileHeader obj={obj} />
											</div>
											<div className='col d-flex align-items-center flex-column flex-grow-0'>
												<button
													className='btn btn-primary w-100 mb-3'
													onClick={this.actionJoin.bind(this, obj, true)}
												>
													Accept
												</button>

												<button
													className='btn btn-danger w-100'
													onClick={this.actionJoin.bind(this, obj, false)}
												>
													Reject
												</button>
											</div>
										</div>
									);
								})}
							</div>
						)}
					</div>
				),
			},
		];

		if (
			admin &&
			props.feed[obj] &&
			props.feed[obj].followers &&
			props.users[obj]
		) {
			const followers = this.props.feed[obj].followers;

			const followKeys = Object.keys(followers.p).filter((a) => {
				return !followers.p[a].d;
			});

			const next = followers.i.total - followKeys.length;

			if (!this.gotFollowers) {
				//required to setup get morefollowers startCursor

				this.gotFollowers = true;

				this.showMoreFollowers('2100-01-01 00:00:00');
			}

			tabs.push({
				title: 'Followers',
				pane: (
					<div>
						<UserSearch
							obj={obj}
							drawRow={(user) => this.showUserSnapShot(user.id + '-u', user)}
						/>

						<div className={classnames('animated fadeIn mt-2')}>
							{followKeys.map((key, index) => {
								const user = this.props.users[key];

								if (!user) {
									return null;
								}

								return this.showUserSnapShot(key, user);
							})}
						</div>

						{followKeys.length > 0 && next > 0 && (
							<div className='col-12 text-center'>
								<button
									className='btn btn-primary btn-sm'
									onClick={() => this.showMoreFollowers()}
								>
									More...
								</button>
							</div>
						)}
					</div>
				),
			});
		}

		return tabs;
	};

	showUserSnapShot(obj, user) {
		return (
			<ShowUserSnapShot
				key={obj}
				user={user}
				obj={obj}
				underName={
					<div className='mt-4 text-right'>
						<BlockUser
							obj={obj}
							user={obj}
							buttonText={<span className='btn btn-primary'>Block</span>}
						/>
					</div>
				}
			/>
		);
	}

	showMoreFollowers = (startCursor) => {
		const { obj, feed } = this.props;

		const followers = feed[obj].followers;

		if (!startCursor) {
			startCursor = followers.i.startCursor;
		}

		socialHttp(
			'get',
			'/data/relationships/' +
				obj +
				'/followers?before=' +
				startCursor +
				'&first=20'
		).catch((e) => {
			throw e;
		});
	};

	render() {
		const state = this.state;

		const props = this.props;

		const { obj, joinRequests } = state;
		const user = props.users[obj];

		const feed = props.feed[obj];

		if (!areFeelsLoaded() || !feed || feed.i === undefined) {
			return (
				<div
					className='card panel-white post panel-shadow text-center'
					style={{ padding: '30px 0' }}
				>
					<Loading />
				</div>
			);
		}

		return (
			<div className='container social_profile'>
				{!user ? (
					<div className='row'>
						<div className='col-md col-12 text-center'>Group doesn't exist</div>
					</div>
				) : (
					<div className='row'>
						<div className='col-md col-12'>
							<div className='row mb-2'>
								<div className='col profile-photo-container text-center'>
									<img
										src={Image(user.image, 200)}
										className='profile-photo rounded show-in-modal'
										style={{ padding: '2px', border: 'solid 1px #bbb' }}
									/>
								</div>

								<div className='col profile-opts'>
									<div>
										<span className='user-name'>
											{user.first_name + ' ' + user.last_name}
										</span>
									</div>

									<div>
										<span
											dangerouslySetInnerHTML={{
												__html: feed.header
													.replace(/&/g, '&amp;')
													.replace(/</g, '&lt;')
													.replace(/>/g, '&gt;')
													.replace(/"/g, '&quot;')
													.replace(/\n/g, '<br />'),
											}}
										/>
									</div>

									<div className='d-flex mt-2 justify-content-end'>
										{!feed.private && !feed.role && (
											<button
												className='btn btn-primary mr-2'
												onClick={this.joinGroup}
											>
												Join
											</button>
										)}

										<ProfileSettings obj={obj} />
									</div>
								</div>
							</div>

							<Tabs uri={'/profile/' + obj} tabs={this.tabs()} />
						</div>
						<div className='col-md-250'>
							<div className='followers_container'>
								<Scrollbars
									style={{ height: '100%', width: '100%', overflowX: 'hidden' }}
								>
									<Followers obj={obj} />
								</Scrollbars>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

Group = ReduxConnect(Group, {
	feels: 'feels',
	feed: 'feed',
	users: 'users',
});

export default withRouter(Group);
